import reactSelectStyles from '../Select/Select.styles';
import { StylesConfig } from 'react-select';
import colors from '../styles/colors';

const units = (i: number) => `${(i * 0.8).toFixed(1)}rem`;

export const countryCodeSelectStyles: StylesConfig = {
  ...reactSelectStyles,
  menu: (base, state) => ({
    ...base,
    ...(reactSelectStyles.menu && reactSelectStyles.menu(base, state)),
    marginTop: units(1),
    borderTop: `1px solid ${
      state.selectProps['errorMessage'] ? colors.red800 : colors.blue800
    }`,
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
    width: 'auto',
  }),
  menuList: (base, state) => ({
    ...base,
    ...(reactSelectStyles.menuList && reactSelectStyles.menuList(base, state)),
    borderTop: 'none',
    width: 'auto',
  }),
  option: (base, state) => ({
    ...base,
    ...(reactSelectStyles.option && reactSelectStyles.option(base, state)),
    whiteSpace: 'nowrap',
    minWidth: '22rem',
  }),
};
